var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7701 2.36715C20.843 2.48324 20.9008 2.62115 20.9402 2.77298C20.9797 2.92481 21 3.08757 21 3.25195C21 3.41634 20.9797 3.5791 20.9402 3.73093C20.9008 3.88276 20.843 4.02067 20.7701 4.13676L9.81504 21.6328C9.74235 21.7492 9.656 21.8416 9.56094 21.9046C9.46587 21.9676 9.36395 22 9.26103 22C9.1581 22 9.05619 21.9676 8.96112 21.9046C8.86605 21.8416 8.7797 21.7492 8.70701 21.6328L3.22948 12.8848C3.08255 12.6501 3 12.3319 3 12C3 11.6681 3.08255 11.3499 3.22948 11.1152C3.37641 10.8805 3.5757 10.7487 3.78349 10.7487C3.99129 10.7487 4.19057 10.8805 4.33751 11.1152L9.26103 18.9809L19.6621 2.36715C19.7348 2.25077 19.8211 2.15843 19.9162 2.09543C20.0113 2.03243 20.1132 2 20.2161 2C20.319 2 20.4209 2.03243 20.516 2.09543C20.6111 2.15843 20.6974 2.25077 20.7701 2.36715Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.5e4f1aece4f4415eb63f153838d82f6b.svg";
export { ForwardRef as ReactComponent };